<!-- 旗舰话费 -->
<template>
  <div>

    <!-- title img -->
    <div class="title">
      <div class="pannel-pay-title">
        <img src="/imgs/bee_head.png" />
      </div>
    </div>

    <!-- orderID -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- time left -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!-- copy -->
    <div class="pannel" style="" v-if="orderInfo.upiPayCopy">
      <div class="infoContainer">
        <div class="items1">UPI:</div>
        <div class="items2">
          <span v-if="copyAccountIf" style="color: green;"><b>{{orderInfo.recAccount}}</b></span>
          <span v-else style="color: blue;"><b>{{orderInfo.recAccount}}</b></span>
        </div>
        <div class="items3">
          <button v-on:click="copyAccount" class="btn copy">Copy</button>
        </div>
      </div>
      <div class="infoContainer">
        <div class="items1">Amount:</div>
        <div class="items2">
          <span v-if="cptyAmountIf" style="color: green;"><b>{{orderInfo.amount}}</b></span>
          <span v-else style="color: red;"><b>{{orderInfo.amount}}</b></span>
        </div>
        <div class="items3">
          <button @click="copyAmount" class="btn copy">Copy</button>
        </div>
      </div>
    </div>

    <!-- submit UTR  -->
    <div style="margin-bottom:10px;" v-if="orderInfo.orderId">
      <div class="submit-container">
        <input type="text" v-model="utr" placeholder="Enter 12-UTR No." style="width: 50%; font-size: 1em; height: 1.5em; padding: 0 10px; border: 1px solid #ccc;" />
        <button type="button" @click="submitUTR()" style="height: 1.5em; padding: 0 1.5em; font-size: 1em;">submit</button>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!-- other pay -->
    <div class="pannel" v-if="recQrUrlImg&&orderInfo.upiPayQrcode">
      <div class="pay-flow">
        <p style="color: #4CAF50;"><b>You can also try scan QrCode:</b></p>
      </div>
      <div style="padding-bottom:0.5em;">
        <table>
          <tr>
            <td style="width: 50%;">
              <div>
                <img :src="recQrUrlImg" style="margin: 0 auto;width: 80%;" />
              </div>
            </td>
            <td style="width: 50%;">
              <div class="pay-flow" style="font-size: 0.8em;">
                <p class="no">1. Download and save the QR code image</p>
                <p class="no">2. Scan & Pay with any UPI App</p>
              </div>
              <div class="pannel-btn">
                <a class="btn down down-zise" :href="recQrUrlImg" :download="`${orderInfo.orderId}-${orderInfo.amount}.png`" style="padding:0.4em;">Download</a>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <!--唤醒按钮-->
      <div class="pannel pannel-btn" v-if="orderInfo.upiPayBtn">
        <div style="padding-bottom:0.5em;">
          <a :href="orderInfo.recQrUrl" class="btn btn-n1" style="width: 70%;">One-click Payment</a>
        </div>
      </div>
    </div>

    <!-- 图片广告 -->
    <div class="" style="margin-top:1em;">
      <div class="pannel-pay-title">
        <img src="/imgs/bee_b1.png" />
      </div>
    </div>
    <div class="">
      <div class="pannel-pay-title">
        <img src="/imgs/bee_b2.png" />
      </div>
    </div>

    <!-- 弹出确认框 -->
    <div class="vdf-modal" v-if="showMsg1">
      <div class="vdf-modal-content">
        <div style="font-size: 0.95em;">Reference Code submitted successfully！</div>
        <button class="btn bankcard-copy" @click="rcodeClose">OK</button>
      </div>
    </div>

  </div>
</template>

<script>
import * as apis from "@/apis/apis";
//
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
//
import QRCode from "qrcode";
//
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 复制相关
      copyAccountIf: false,
      cptyAmountIf: false,
      //
      recQrUrlImg: "",
      utr: "",
      //
      showMsg1: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    //
    init() {
      console.log(this.orderInfo);
      this.utr = this.orderInfo.membUtr;
      // 生成二维码;
      if (this.orderInfo.recQrUrl) {
        QRCode.toDataURL(
          this.orderInfo.recQrUrl,
          { errorCorrectionLevel: "L", margin: 1, width: 500 },
          (err, url) => {
            if (err) {
              return;
            }
            this.recQrUrlImg = url;
          }
        );
      }
    },
    // 测试已支付
    devPayd() {
      apis
        .devPayd({
          id: this.orderInfo.orderId,
        })
        .then((res) => {
          console.log(res);
          location.reload();
        })
        .catch((err) => {
          console.log("发生错误");
          console.log(err);
        });
    },
    // 复制手机
    copyAccount: function () {
      this.$parent.copySome(
        this.orderInfo.recAccount,
        1,
        () => {
          this.copyAccountIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制金额
    copyAmount: function () {
      this.$parent.copySome(
        this.orderInfo.amount,
        2,
        () => {
          this.cptyAmountIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    submitUTR() {
      if (this.utr.length != 12) {
        return;
      }
      apis
        .upiPayUtr({
          id: this.orderInfo.orderId,
          utr: this.utr,
        })
        // eslint-disable-next-line
        .then((res) => {
          this.showMsg1 = true;
        })
        // eslint-disable-next-line
        .catch((err) => {
          console.log(err);
        });
    },
    rcodeClose() {
      this.showMsg1 = false;
    },
  },
};
</script>

<style>
.submit-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>

<style lang="scss" scoped>
</style>
